// NOTE: datePicker is used in Project Planner and implemented in cart for project planner items
// TODO: replace datepicker with no-jquery plugin.

window.lp.utils.initializeDatePicker = function ($dateField, options = {}) {

	const defaultOptions = {
		minDate: 0, // disable past dates
		dateFormat: 'mm/dd/y', // e.g. 01/01/15
		showOn: 'button',
		buttonText: '' // in most cases, actual text doesn't matter as button will be styled using an icon or date input field is hidden behind a link
	};

	return $dateField.datepicker({ ...defaultOptions, ...options });

};
